<template>
  <v-row no-gutters justify="center" align="center">
    <div class="py-8 px-4" v-if="!this.getPlanRight(`inbox`) && false">
      <not-available-in-free-plan item="Inbox" />
    </div>
    <div class="n-container-small pt-6 mx-6" v-else>
      <div class="tabs-container relative">
        <v-tabs
          v-model="currentTab"
          slider-color="#ffd641"
          slider-size="3"
          hheight="40px"
        >
          <v-tab>
            <v-badge
              :value="hasInboxRecurrentInterventions"
              bordered
              color="error"
              :content="countInboxRecurrentInterventions"
            >
              Interventions récurrentes
            </v-badge>
          </v-tab>
          <v-tab>
            <v-badge
              :value="hasInboxOnlineInterventions"
              bordered
              color="error"
              :content="countInboxOnlineInterventions"
            >
              Formulaire en ligne
            </v-badge>
          </v-tab>
        </v-tabs>
        <v-row
          no-gutters
          justify="center"
          align="center"
          style="position: absolute; right: 0px; top: 0px; height: 100%;"
          v-if="isFetchingRecurrentInterventions"
        >
          <div class="pr-2">
            <v-progress-circular
              indeterminate
              color="accent"
              :width="3"
              :size="20"
            />
          </div>
        </v-row>
      </div>
      <div>
        <router-view />
      </div>
    </div>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  data: () => ({
    currentTab: 0,
  }),

  computed: {
    ...mapState(`ui/mainLayout`, [
      `countInboxRecurrentInterventions`,
      `countInboxOnlineInterventions`,
    ]),
    ...mapGetters(`ui/mainLayout`, [
      `hasInboxRecurrentInterventions`,
      `hasInboxOnlineInterventions`,
    ]),
    ...mapGetters(`ui/inboxRecurrentInterventions`, [
      `isFetchingRecurrentInterventions`,
    ]),
    currentRouteName() {
      if (this.currentTab === 0) {
        return `inboxRecurrentInterventions`;
      }

      return `inboxOnline`;
    },
  },

  methods: {
    setCurrentTabFromUrl() {
      if (this.$route.name === `inboxOnline`) {
        this.currentTab = 1;
      } else {
        this.currentTab = 0;
      }
    },
    goToCurrentTab() {
      if (this.$route.name === `inbox`) {
        this.$router.replace({ name: this.currentRouteName });
      } else if (this.$route.name !== this.currentRouteName) {
        this.$router.push({ name: this.currentRouteName });
      }
    },
  },

  watch: {
    currentTab() {
      this.goToCurrentTab();
    },
    '$route.path': function routePathChanged() {
      this.goToCurrentTab();
    },
  },

  beforeMount() {
    this.setCurrentTabFromUrl();
    this.goToCurrentTab();
  },
};
</script>

<style lang="scss">
$secondaryColor: #ffd641;
.tabs-container {
  position: relative;
  .v-tabs {
    &, * {
      z-index: 10;
    }
  }
  .v-slide-group__wrapper::after {
    content: " ";
    position: absolute;
    bottom: 1px;
    left: 0px;
    right: 0px;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
  }
  .v-tab {
    letter-spacing: 0.04rem !important;
  }
}
</style>
